// zbrainSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ZbrainAgent } from '../../common/types/common';

interface ZbrainState {
  zbrainWorkers: ZbrainAgent[];
  error: boolean;
}

const initialState: ZbrainState = {
  zbrainWorkers: [],
  error: false,
};

const zbrainSlice = createSlice({
  name: 'zbrain',
  initialState,
  reducers: {
    setZbrainWorkers: (
      state,
      action: PayloadAction<{ zbrainWorkers: ZbrainAgent[]; error: boolean }>
    ) => {
      state.zbrainWorkers = action.payload.zbrainWorkers;
      state.error = action.payload.error;
    },
    clearZbrainWorkers: (state) => {
      state.zbrainWorkers = [];
      state.error = false;
    },
  },
});

export const { setZbrainWorkers, clearZbrainWorkers } = zbrainSlice.actions;
export default zbrainSlice.reducer;
